<template>
  <form @submit.prevent="submit">
    <fg-input label="Name"
      type="text"
      v-model="productCat.name"
      :error="valErrors['name'] ? valErrors['name'][0] : null"
    />
    <div>
      <label>Gehört zu Produktkategorie</label>
    <div class="form-group has-label">
      <multiselect v-model="productCat.parent_category"
        :options="productCategories"
        track-by="id"
        label="name"
      />
    </div>
    </div>
    <fg-input label="Buchhaltungs-Konto"
      type="text"
      v-model="productCat.accounting_number"
      :error="valErrors['accounting_number'] ? valErrors['accounting_number'][0] : null"
    />
    <button type="submit" class="btn btn-fill btn-info">{{ submitText }}</button>
  </form>
</template>

<script>
export default {
  props: ['valErrors', 'productCategories', 'initProductCategory', 'submitText'],
  data () {
    return {
      productCat: this.initProductCategory
    }
  },
  methods: {
    submit () {
      this.productCat.product_category_id = this.productCat.parent_category ? this.productCat.parent_category.id : null
      this.$emit('submit', this.productCat)
    }
  }
}
</script>

<style>
</style>
